import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { confirmDeletePersonCards } from './confirmation';
import { useDeleteCards } from '@vlabs/api/point-api/client';
import type { CardId } from '@vlabs/api/point-api/model';

interface UseDeleteCardsHandlerProps {
  cardIds?: CardId[];
}
type UseDeleteCardsHandlerReturn = (() => Promise<void>) | undefined;

export function useDeleteCardsWithConfirmation({
  cardIds = undefined,
}: UseDeleteCardsHandlerProps): UseDeleteCardsHandlerReturn {
  const deleteCards = useDeleteCards();
  const { t } = useTranslation();

  if (!cardIds) return undefined;

  return async (): Promise<void> => new Promise((resolve, reject) => {
    if (!cardIds) {
      resolve();
      return;
    }
    confirmDeletePersonCards({
      externalIds: cardIds,
      onConfirm: () => {
        deleteCards.mutateAsync({
          data: { card_ids: cardIds },
          params: { ignore: 1 },
        }, {
          onSuccess: () => {
            toast.success(t('features:deletePerson.success'));
            resolve();
          },
          onError: reject,
        });
      },
      onReject: reject,
    });
  });
}
